export default __webpack_public_path__ + "static/media/advicegradissuegfx-16.e7bdf486.png";